import { Box } from '../../foundation/Box/index.js';
import { useState, useRef, useLayoutEffect } from 'react';
import { Container, Content, HeaderActionsContainer, Header, StyledTypography, Actions } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { GridContainer } from '../../foundation/Grid/styled.js';
import { Tooltip } from '../../dataDisplay/Tooltip/Tooltip/index.js';

function PageHeader(props) {
  var actions = props.actions,
    breadcrumbs = props.breadcrumbs,
    heading = props.heading,
    chip = props.chip,
    tabs = props.tabs,
    secondary = props.secondary;
  var _useState = useState(true),
    truncated = _useState[0],
    setTruncated = _useState[1];
  var _useState2 = useState(),
    tooltipWidth = _useState2[0],
    setTooltipWidth = _useState2[1];
  var headingRef = useRef(null);
  var withTabs = Boolean(tabs);
  useLayoutEffect(function () {
    var observeTruncate = function observeTruncate() {
      var _ref = headingRef.current || {},
        _ref$offsetHeight = _ref.offsetHeight,
        offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight,
        _ref$scrollHeight = _ref.scrollHeight,
        scrollHeight = _ref$scrollHeight === void 0 ? 0 : _ref$scrollHeight,
        clientWidth = _ref.clientWidth;
      setTruncated(offsetHeight < scrollHeight);
      setTooltipWidth(clientWidth);
    };
    observeTruncate();
    window.addEventListener('resize', observeTruncate);
    return function () {
      return window.removeEventListener('resize', observeTruncate);
    };
  }, [heading, secondary, actions]);
  return /*#__PURE__*/jsx(Container, {
    $withTabs: withTabs,
    children: /*#__PURE__*/jsx(GridContainer, {
      children: /*#__PURE__*/jsxs(Box, {
        flexDirection: "column",
        children: [breadcrumbs, /*#__PURE__*/jsxs(Content, {
          children: [/*#__PURE__*/jsxs(HeaderActionsContainer, {
            children: [/*#__PURE__*/jsxs(Header, {
              children: [/*#__PURE__*/jsx(Tooltip, {
                disabled: !truncated,
                title: heading,
                width: tooltipWidth,
                children: /*#__PURE__*/jsx(StyledTypography, {
                  ref: headingRef,
                  children: heading
                })
              }), chip]
            }), actions && /*#__PURE__*/jsx(Actions, {
              children: actions
            })]
          }), secondary]
        }), tabs]
      })
    })
  });
}

export { PageHeader };
